// PROJ-20333 Course interest form removed from scope for v1 launch
// Commented out imports belong to the form
// import {Form} from "react-aria-components";
// import Button, {
// 	ButtonSizes,
// 	ButtonVariant,
// } from "../../../../_components/Button";
// import Link from "next/link";
// import BorderlessTextField, {
// 	BorderlessInput,
// } from "../../../../_components/forms/BorderlessTextField";
import Campus from "../../../../../types/Campus";
import {FCWithHTMLAttributes} from "../../../../../types/reactTypes";
import AvailableSessionErrorWrapper from "./AvailableSessionErrorWrapper";

export enum NoSessionsMode {
	ANYWHERE = "ANYWHERE",
	NEAR_YOU = "NEAR_YOU",
	AT_CAMPUS = "AT_CAMPUS",
	COMING_SOON = "COMING_SOON",
}

interface NoSessionsAvailableProps {
	courseId: string;
	noSessionsMode: NoSessionsMode;
	campus: Campus;
}

const NoSessionsAvailable: FCWithHTMLAttributes<NoSessionsAvailableProps> = ({
	noSessionsMode,
	campus,
	className,
}) => {
	let heading;
	switch (noSessionsMode) {
		case NoSessionsMode.ANYWHERE:
			heading = "This course isn't currently available.";
			break;
		case NoSessionsMode.NEAR_YOU:
			heading = "This course isn't currently available near you.";
			break;
		case NoSessionsMode.AT_CAMPUS:
			heading = `This course isn't currently available at ${campus.fullName}.`;
			break;
		case NoSessionsMode.COMING_SOON:
			heading = `${campus.fullName} is coming soon! Stay tuned for course offerings!`;
			break;
	}
	return (
		<AvailableSessionErrorWrapper className={className}>
			<div>
				<h3 className="title-h2 mb-4">{heading}</h3>
				{/* PROJ-20333 Course interest form removed from scope for v1 launch */}
				{/* <p>
					Try another campus above, or fill out this course interest form to be
					notified when new sections for this course are opened.
				</p> */}
			</div>
			{/* PROJ-20333 Course interest form removed from scope for v1 launch */}
			{/* <Form className="mt-6 flex w-full flex-col items-start gap-10 text-left lg:mt-0 lg:flex-row lg:items-center lg:justify-center">
				<BorderlessTextField
					className="w-full lg:max-w-screen-xs"
					isRequired
					name="Email or Username"
					type="text"
					labelText="Email or Username"
				>
					<BorderlessInput className="w-full" placeholder="me@example.com" />
				</BorderlessTextField>
				<Button
					className="flex h-12 items-center lg:h-auto"
					size={ButtonSizes.SMALL}
					variant={ButtonVariant.SECONDARY}
				>
					GET&nbsp;NOTIFIED
				</Button>
			</Form>
			<div>
				Your information will be used in accordance with our{" "}
				<Link className="text-hyperlink" href="/legal/privacy">
					Privacy Policy
				</Link>
				.
			</div> */}
		</AvailableSessionErrorWrapper>
	);
};

export default NoSessionsAvailable;
